import { MAIN_HEADER_HEIGHT, PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import { HTMLAttributes } from 'react'

export function TablePageContainer({
  children,
  fullHeight = false,
  className,
  style,
}: {
  children: React.ReactNode
  fullHeight?: boolean
  className?: string
  style?: HTMLAttributes<HTMLDivElement>['style']
}) {
  return (
    <div
      style={
        style ?? {
          height: `calc(100vh - ${MAIN_HEADER_HEIGHT * 2}px${fullHeight ? '' : ` - ${PAGE_HEADER_HEIGHT}px`})`,
        }
      }
      className={className}
    >
      {children}
    </div>
  )
}
